import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTraGis {
  name: string;
  api_token: string;
}

export interface CuocDieuTraGisListInfor {
  errors: unknown;
  cuocDieuTraGis: CuocDieuTraGis;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraGisModule
  extends VuexModule
  implements CuocDieuTraGisListInfor
{
  errors = {};
  cuocDieuTraGis = {} as CuocDieuTraGis;
  isAuthenticated = !!JwtService.getToken();

  get CuocDieuTraGises() {
    return this.cuocDieuTraGisesListData;
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_GISES_LIST_DATA](CuocDieuTraGis) {
    this.cuocDieuTraGisesListData = CuocDieuTraGis;
  }

  @Action
  [Actions.CUOC_DIEU_TRA_GIS_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmcuocdieutra/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_GISES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_GIS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmcuocdieutra", payload)
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_GISES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_GIS_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "gis/dmcuocdieutra",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_GISES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_GIS_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "gis/dmcuocdieutra",
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_GISES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
